<template>
  <div class="video-component-wrap" :id="'video' + Object.values(myid).join('')" ref="videoWrap">
    <div v-if="videoTransferring" class="video-transfer-box">
      <div class="tips-center">
        <i class="icon-portal-transcoding fs22"></i>
        <p class="fs16 mt8">视频转码中</p>
      </div>
    </div>
    
    <img v-else-if="videoImageUrl" class="video-img-box" :src="videoImageUrl" alt="">
    <div v-else class="video-component" @click.stop.prevent @click="videoDialogPlayHandle" :style="getVideoStyle">
      <div class="video-container" ref="videoInner" @click.stop="videoDialogPlayHandle1">
        <!-- 视频 -->
        <video
          :poster="uploadVideoImg"
          :id="'myVideo' + Object.values(myid).join('')"
          class="video-js vjs-default-skin vjs-big-play-centered"
          :class="autoplayStatus ? 'autoPlay' : ''"
          ref="videoPlayer"
        >
          <source v-if="ifLive && videoSrc && videoSrc.length > 0" :src="videoSrc" type="application/x-mpegURL" />
          <source v-else-if="videoSrc && videoSrc.length > 0" :src="videoSrc" type="video/ogg" />
        </video>
      </div>
    </div>
  </div>
</template>

<script>
import { isBigScreenPreview } from "utils/index"
import Video from "video.js"
import eventMixin from "utils/event/eventMixin.js"
import dataRenderMixin from "materials/dataRenderMixin"

export default {
  mixins: [eventMixin, dataRenderMixin],
  name: "cxvideo",
  props: {
    options: {
      type: Object,
      default: null
    },
    myid: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      myplayer: null,
      isError: false,
      dialogPlayStatus: false,
      oldPos: [],
      ifLive: false,
      inDialog: false,
      bigscreenViewDialog: false
    }
  },
  mounted() {
    this.$initPlugin(this.options?.pluginName)
    if (isBigScreenPreview() && !this.options.dialogPlay) {
      this.bigscreenViewDialog = true
    } else {
      this.bigscreenViewDialog = false
    }
    this.initVideoHandle()
    if(this.options.detailFieldMapping?.isChecked){
      this.updateData()
    }
    setTimeout(() => {
      this.videoPauseBtnHandle(this.getVideoButtonStyle)
    })
    setTimeout(() => {
      const vcontrol = this.$el.querySelector(".vjs-control-bar")
      if (vcontrol) {
        if (this.options.controlStatus) {
          vcontrol.style.display = "flex"
        } else {
          vcontrol.style.display = "none"
        }
      }
    }, 500)
  },
  beforeDestroy() {
    if (this.myPlayer) {
      this.myPlayer.dispose()
    }
  },
  computed: {
    uploadVideoImg() {
      return this.options.uploadVideoImg
    },
    videoTransferring: {
      get() {
        return this.options.videoTransferring || false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "videoTransferring", false)
      }
    },
    videoImageUrl() {
      const videoImageUrl = this.options.videoImageUrl
      if (videoImageUrl) {
        this.$changeOptionsEV("", "objectId", false, null, this.myid)
        this.$changeOptionsEV("", "videoUrl", false, null, this.myid)
      }
      return videoImageUrl
    },
    videoSrc() {
      if (this.options.videoImageUrl) return ""
      if (this.options.objectId) {
        let ypDataUrl = "//yp.mh.chaoxing.com/upload/yunpan/" + this.options.objectId + "/status"
        this.instance.get(ypDataUrl).then(res => {
          console.log("videoSrc", res)
          console.log("res.data.status", res.data.status)
          if(res.data.status === "transfer"){
            //转码中
            this.videoTransferring = true
          }else{
            this.videoTransferring = false
            this.myPlayer.reset() //重置 video
            this.myPlayer.src([
              {
                src: res.data.http
              }
            ])
            this.initVideoHandle()
            this.myPlayer.load()
            // this.myPlayer.play()
            return res.data.http
          }
        })
      } else {
        // 测试地址
        //http://vjs.zencdn.net/v/oceans.mp4
        this.judgeVideoType(this.options.videoUrl)
        return this.options.videoUrl ? this.options.videoUrl : require("assets/images/default-video1.mp4")
      }
      // 测试地址
      //http://vjs.zencdn.net/v/oceans.mp4
      // return this.options.videoUrl ? this.options.videoUrl : require("../../../assets/images/default-video.mp4")
    },
    posterSrc() {
      return this.options.imgSrc ? this.options.imgSrc : ""
    },
    loopPlay() {
      return this.options.loopPlay
    },
    autoplayStatus() {
      return this.options.autoplayStatus
    },
    muted() {
      return this.options.muted
    },
    // 弹框播放原位播放
    dialogPlay() {
      return this.options.dialogPlay
    },
    // 显示控制条
    controlStatus() {
      return this.options.controlStatus
    },
    themeColor() {
      return this.$store.state[this.request_prefix].page.themeColor
    },
    boxShadowStyle() {
      let tmpStyle = ""
      let _this = this
      if (Array.isArray(this.options.boxShadowH)) {
        this.options.boxShadowH.forEach((item, index) => {
          if (index > 0) {
            tmpStyle += ","
          }
          tmpStyle += `${_this.options.boxShadowH[index]}px ${_this.options.boxShadowV[index]}px ${_this.options.boxShadowBlur[index]}px ${_this.options.boxShadowSpread[index]}px ${this.$parseColor(_this.options.boxShadowColor[index])}`
        })
      } else {
        tmpStyle += `${this.options.boxShadowH}px ${this.options.boxShadowV}px ${this.options.boxShadowBlur}px ${this.options.boxShadowSpread}px ${this.$parseColor(this.options.boxShadowColor)}`
      }
      return tmpStyle
    },
    getVideoStyle() {
      let borderW = ""
      if (Array.isArray(this.options.borderWidth)) {
        this.options.borderWidth.forEach(item => [(borderW += ` ${item}px`)])
      } else {
        borderW += ` ${this.options.borderWidth}px`
      }
      return {
        // width: this.options.width + "px",
        // height: this.options.height + "px",
        top: this.options.top + "px",
        left: this.options.left + "px",
        transform: "rotate(" + this.options.rotate + "deg)",
        padding: this.options.videolegendPadding + "px",
        paddingTop: this.options.videoPaddingTop + "px",
        paddingRight: this.options.videoPaddingRight + "px",
        paddingBottom: this.options.videoPaddingBottom + "px",
        paddingLeft: this.options.videoPaddingLeft + "px",
        opacity: this.options.opacity / 100,
        "box-shadow": this.boxShadowStyle,
        "border-top-left-radius": this.options.borderTopLeftRadius + "px",
        "border-top-right-radius": this.options.borderTopRightRadius + "px",
        "border-bottom-right-radius": this.options.borderBottomRightRadius + "px",
        "border-bottom-left-radius": this.options.borderBottomLeftRadius + "px",
        "border-style": this.options.borderStyle,
        // "border-color": this.options.borderIsThemeColor
        //   ? this.themeColor
        //   : this.options.borderColor.color
        //   ? this.options.borderColor.color
        //   : this.options.borderColor,
        "border-color": this.$parseColor(this.options.borderColor, {
          isThemeColor: this.options.borderIsThemeColor
        }),
        // "border-color": this.options.borderIsThemeColor
        //   ? this.themeColor
        //   : this.options.borderColor.color
        //   ? this.options.borderColor.color
        //   : this.options.borderColor,
        "border-width": borderW
      }
    },
    getVideoButtonStyle() {
      let iconBorderW = ""
      if (Array.isArray(this.options.iconBorderWidth)) {
        this.options.iconBorderWidth.forEach(item => [(iconBorderW += ` ${item}px`)])
      } else {
        iconBorderW += ` ${this.options.iconBorderWidth}px`
      }
      return {
        width: this.options.iconWidth + "px",
        height: this.options.iconHeight + "px",
        // color: this.options.iconColorIsThemeColor
        //   ? this.themeColor
        //   : this.options.iconColor.color
        //   ? this.options.iconColor.color
        //   : this.options.iconColor,
        // backgroundColor: this.options.iconBgIsThemeColor
        //   ? this.themeColor
        //   : this.options.bgColor.color
        //   ? this.options.bgColor.color
        //   : this.options.bgColor,
        color: this.$parseColor(this.options.iconColor, {
          isThemeColor: this.options.iconColorIsThemeColor
        }),
        backgroundColor: this.$parseColor(this.options.bgColor, {
          isThemeColor: this.options.iconBgIsThemeColor
        }),
        borderStyle: this.options.iconBorderStyle,
        borderWidth: iconBorderW,
        borderColor: this.$parseColor(this.options.iconBorderColor),
        // borderColor: this.options.iconBorderColor.color
        //   ? this.options.iconBorderColor.color
        //   : this.options.iconBorderColor,
        borderRadius: this.options.hasOwnProperty("iconRadius") ? this.options.iconRadius + "px" : "50%"
      }
    },
    noCacheComponent() {
      return this.options && this.options.noCacheComponent ? this.options.noCacheComponent : false
    },
    // 画布宽高
    cWidth() {
      return this.getAttrById(this.$store.state[this.request_prefix], { container_id: this.myid.container_id }).width
    },
    cHeight() {
      return this.getAttrById(this.$store.state[this.request_prefix], { container_id: this.myid.container_id }).height
    },
    filedMapping() {
      return this.options.filedMapping &&
        this.options.filedMapping.value !== null &&
        typeof this.options.filedMapping.value !== "undefined"
        ? true
        : false
    }
  },
  watch: {
    uploadVideoImg(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.myPlayer.poster_ = newVal
        this.myPlayer.trigger("posterchange")
      }
    },
    getVideoButtonStyle: {
      // immediate:true,
      handler: function (val) {
        this.videoPauseBtnHandle(val)
      }
    },
    controlStatus: function (val) {
      const vcontrol = this.$el.querySelector(".vjs-control-bar")
      if (val) {
        vcontrol.style.display = "flex"
      } else {
        vcontrol.style.display = "none"
      }
    },
    videoSrc(val) {
      if (!this.myPlayer) return
      this.judgeVideoType(val)
      this.myPlayer.reset() //重置 video
      this.myPlayer.src([
        {
          src: val
        }
      ])
      this.myPlayer.load()
      this.myPlayer.play()
    },
    "options.detailFieldMapping": {
      deep: true,
      handler(n, o) {
        if (n) {
          this.updateData()
        }
        if (n && !n?.isChecked) {
          this.$changeOptionsEV("", "objectId", false, null, this.myid)
          this.$changeOptionsEV("", "videoUrl", false, null, this.myid)
        }
      }
    },
    // 首页字段匹配
    "options.videoUrl": {
      deep: true,
      handler(n, o) {
        if (typeof n === "string" && this.filedMapping) {
          if (n.includes(".mp4") || n.includes(".m3u8")) {
            this.$changeOptionsEV("", "objectId", false, null, this.myid)
          } else {
            this.$changeOptionsEV(n, "objectId", false, null, this.myid)
            // this.$changeOptionsEV("", "videoUrl", false, null, this.myid)
          }
        }
      }
    }
  },
  methods: {
    async updateData() {
      this.updateNormalRect.call(this, data => {
        console.log("updateCb", data)
        if (typeof data === "string") {
          if (data.includes(".mp4")) {
            this.$changeOptionsEV(data, "videoUrl", false, null, this.myid)
          } else {
            this.$changeOptionsEV(data, "objectId", false, null, this.myid)
          }
        }else if(typeof data === 'object'){
          // 视频详情情况
          if(data.objectId){
            this.$changeOptionsEV(data.objectId, "objectId", false, null, this.myid)
          }
          if(data.videoCover){
            this.$changeOptionsEV(data.videoCover, "uploadVideoImg", false, null, this.myid)
          }
        }
      })
    },
    initVideoHandle() {
      this.$nextTick(function () {
        if(this.myPlayer || !this.$refs.videoPlayer) {
          return
        }
        this.myPlayer = Video(this.$refs.videoPlayer, {
          //确定播放器是否具有用户可以与之交互的控件。没有控件，启动视频播放的唯一方法是使用autoplay属性或通过Player API。
          controls: true,
          //自动播放属性,muted:静音播放
          autoplay: this.autoplayStatus,
          //建议浏览器是否应在<video>加载元素后立即开始下载视频数据。
          preload: "auto",
          //设置视频播放器的显示宽度（以像素为单位）
          width: "100%",
          //设置视频播放器的显示高度（以像素为单位）
          height: "100%",
          poster: this.posterSrc,
          loop: this.loopPlay,
          muted: true,
          userActions: {
            doubleClick: !this.bigscreenViewDialog
          }
        })
        if(this.autoplayStatus && !this.muted) {
          this.myPlayer.on("play", this.autoPlayListener)
        }
      })
    },
    videoDialogPlayHandle() {
      if (this.dialogPlayStatus) {// 暂停时 重新显示播放按钮
        const vb = this.$refs.videoWrap.querySelector(".vjs-big-play-button")
        if (vb && vb.classList?.length && vb.classList.contains("opacity0")) {
          vb.classList.remove("opacity0")
        }
      }
      this.dialogPlayStatus = !this.dialogPlayStatus
      if (isBigScreenPreview() && !this.options.dialogPlay) {
        //dialogPlay 弹框播放为false 原位播放为true
        if (!this.dialogPlayStatus) {
          this.$changeOptionsEV(this.oldPos[0], "width", false)
          this.$changeOptionsEV(this.oldPos[1], "height", false)
          this.$nextTick(() => {
            this.$changeOptionsEV(this.oldPos[2], "top", false)
            this.$changeOptionsEV(this.oldPos[3], "left", false)
          })
          this.$refs.videoInner.style.width = "100%"
          this.$refs.videoInner.style.height = "100%"
          this.$refs.videoInner.style.marginTop = 0
          this.$refs.videoInner.style.marginLeft = 0
          this.inDialog = false
        } else if (this.dialogPlayStatus) {
          this.oldPos[0] = this.options.width
          this.oldPos[1] = this.options.height
          this.oldPos[2] = this.options.top
          this.oldPos[3] = this.options.left
          this.$changeOptionsEV(0, "top", false)
          this.$changeOptionsEV(0, "left", false)
          this.$nextTick(() => {
            this.$changeOptionsEV(this.cWidth - 1, "width", false)
            this.$changeOptionsEV(this.cHeight - 1, "height", false)
          })
          this.$refs.videoInner.style.width = this.cWidth * 0.6 + "px"
          this.$refs.videoInner.style.height = this.cHeight * 0.6 + "px"
          this.$refs.videoInner.style.marginTop = this.cHeight * 0.2 + "px"
          this.$refs.videoInner.style.marginLeft = this.cWidth * 0.2 + "px"
          this.inDialog = true
        }
      }
    },
    videoPauseBtnHandle(val) {
      const vedioId = "#video" + Object.values(this.myid).join("")
      const vb = document.querySelector(vedioId + " .vjs-big-play-button")
      if (!vb) return
      const vbIcon = document.querySelector(vedioId + " .vjs-big-play-button .vjs-icon-placeholder")
      vb.style.width = val.width
      vb.style.height = val.height
      vb.style.borderStyle = val.borderStyle
      vb.style.borderWidth = val.borderWidth
      vb.style.borderColor = val.borderColor
      vb.style.backgroundColor = val.backgroundColor
      vb.style.borderRadius = val.borderRadius
      vbIcon.style.color = val.color
      vbIcon.style.lineHeight = val.height
      // 【视频】视频自动播放的时候，预览页不显示播放未开始播放的状态
      if (this.autoplayStatus) {
        setTimeout(() => {
          vb.style.opacity = 1
        }, 500)
      } else {
        vb.style.opacity = 1
      }
    },
    judgeVideoType(url) {
      let index = url && url.lastIndexOf(".")
      let ext = url && url.substr(index + 1)
      let type = ext && ext.substr(0, 4)
      if (type === "m3u8") {
        this.ifLive = true
      } else {
        this.ifLive = false
      }
    },
    videoDialogPlayHandle1() {
      if (!this.inDialog) {
        this.videoDialogPlayHandle()
      }
    },
    // 自动触发点击事件播放视频
    autoPlayListener() {
      const event = new MouseEvent("click", {
        bubbles: true,
        cancelable: true
      })
      const videoControl = this.$refs.videoInner.querySelector(".vjs-mute-control")
      videoControl.dispatchEvent(event)
    },
    pauseOtherVideo() {
      const curVideo = document.getElementById(`video${Object.values(this.myid).join("")}`)
      if (curVideo.paused) {
        return
      }
      let videos = document.getElementsByClassName("video-component-wrap")
      for (let i = 0; i < videos.length; i++) {
        const videoId = videos[i].getAttribute("id")
        if (videoId !== `video${Object.values(this.myid).join("")}`) {
          const video = videos[i].getElementsByTagName("video")[0]
          video && !video.paused && video.pause()
        }
      }
    },
  }
}
</script>

<style scoped>
::v-deep.vjs-big-play-centered .vjs-big-play-button {
  margin: 0;
  transform: translate(-50%, -50%);
  font-size: 30px;
  opacity: 0;
}
.video-component-wrap {
  width: 100%;
  height: 100%;
}
.video-component-wrap .video-transfer-box{
  width: 100%;
  height: 100%;
  padding: 16px;
  overflow: hidden;
  background-color: #f6f7f9;
}
.video-component-wrap .video-transfer-box .tips-center{
  font-size: 16px;
  color: rgba(0,0,0,0.4);
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%,-50%);
}
.overflowHidMultiLines {
  word-break: break-all;
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
}
.video-component,
.video-component > div {
  transition: transform 0.5s;
}

.video-component {
  width: 100%;
  height: 100%;
  padding: 16px;
  overflow: hidden;
}
.video-container {
  width: 100%;
  height: 100%;
}

.video-js {
  width: 100%;
  height: 100%;
  background-color: transparent;
}
.vjs-tech {
  outline: none !important;
}
::v-deep .video-js.vjs-paused .vjs-big-play-button {
  display: block;
  margin-top: 0;
  margin-left: 0;
  transform: translate(-50%, -50%);
}
::v-deep .vjs-poster {
  background-color: transparent;
  background-size: cover;
}
.video-component-wrap .video-img-box {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
</style>
